import React from 'react';
import PropTypes from 'prop-types';

import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import { ButtonWithIcon } from '@els/els-react--button';
import StructureOptions from './StructureOptions';

import './StructureOptionsDialog.scss';

function StructureOptionsDialog(props) {
  const { ownCurrentOptions, id, onApplyClick } = props;

  if (!ownCurrentOptions) {
    return (
      <GeneralDialogLayout {...props}>
        <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={id} />
      </GeneralDialogLayout>
    );
  }

  return (
    <GeneralDialogLayout {...props}>
      <StructureOptions {...props} />
      <section className="structure-options-dialog-apply">
        <ButtonWithIcon
          id="structure-options-apply"
          type="primary"
          size="small"
          sprite="ChevronRight"
          iconRight
          data-e2e="e2e-structure-options-dialog-apply-button"
          onClick={onApplyClick}
          className="e2e-structure-dialog-apply">
          Apply
        </ButtonWithIcon>
      </section>
    </GeneralDialogLayout>
  );
}

StructureOptionsDialog.propTypes = {
  id: PropTypes.string.isRequired,
  ownCurrentOptions: PropTypes.object,
  active: PropTypes.bool,
  onApplyClick: PropTypes.func,
};

export default StructureOptionsDialog;
